import React, { createContext } from 'react'

const PPContext = createContext()

export default PPContext
